import { formatPhone } from "../../utils";
import { deleteCustomerAccountBackend, updateUser } from "../../api/backend";
import { updateCustomerHubrise } from "../../api/hubrise";
import store from "../../redux/store";
import {
  listenFirebaseUsersData,
  unlistenFirebase,
} from "../../api/firebase/firebaseOn";
import { logMediumError } from "../../utils/logger";
import {
  showUpdateInfo,
  showAccountModal,
  userSignOut,
  updateProfile,
} from "../../redux/actions";
import { analyticsEvents } from "../../utils/firebaseAnalytics";
import { TEXT_VALIDATION_DELETE_ACCOUNT } from "../../constants";
import { openMessageModal } from "../../utils/common";
import {
  validateFirstName,
  validateLastName,
} from "../../utils/validators";
export const deleteUserAccount = async ({
  showUpdateInfo,
  showAccountModal,
  userSignOut,
  customerId,
  isUserAnonymous,
  updateUser,
  dispatch,
  navigate,
}) => {
  try {
    unlistenFirebase(customerId);
    await deleteCustomerAccountBackend();
    dispatch(userSignOut());
    navigate("/");
    dispatch(showUpdateInfo(false));
    dispatch(showAccountModal(false));
    openMessageModal(`Nous vous confirmons la suppression de votre compte.`)
  } catch (error) {
    openMessageModal(
      `Nous n'avons pas pu supprimer votre compte, veuillez essayer de nouveau.`
    )
    logMediumError(`Error deleting user account ${error}`, { customerId });
    await listenFirebaseUsersData(customerId, isUserAnonymous, updateUser);
  }
};

const updateUserPersonalInfos = async (
  firstName = "",
  lastName = "",
  numero = "",
  phone = {}
) => {
  const { user, userConnected } = store.getState().userReducer;
  if (userConnected) {
    const { customerId } = user;
    await updateUser(customerId, { firstName, lastName, numero, phone });
  }
};

export const updateAccount = async ({
  setLoading,
  phoneObj,
  updateProfile,
  showUpdateInfo,
  user,
  firstName,
  lastName,
  numero,
  dispatch,
}) => {
  try {
    setLoading(true);
    numero = formatPhone(numero);
    dispatch(updateProfile("fistName", firstName));
    dispatch(updateProfile("lastName", lastName));
    dispatch(updateProfile("numero", numero));
    await updateCustomerHubrise(
      { firstName, lastName, numero },
      user?.customerId
    );
    await updateUserPersonalInfos(firstName, lastName, numero, phoneObj);
    dispatch(showUpdateInfo(false));
    setLoading(false);
    const msgUpdateAccount = "Votre compte a bien été mis à jour"
    openMessageModal(msgUpdateAccount, {
      text: "Modifications enregistrées",
      title: "Informations mises à jour",
      subTitle: msgUpdateAccount,
      image: "valid",
      withImage: true
    });
  } catch (error) {
    const errorMessage = error;
    logMediumError(`Could not update user info ${errorMessage}`);
    setLoading(false);
    openMessageModal(
      "La modification de votre compte a échoué. Veuillez vérifier les informations saisies."
    )
  }
};



export const validateForm = (formValues: any) => {
  const errors: any = {};

  const firstNameError = validateFirstName(formValues.firstName);
  if (firstNameError) {
    errors.firstName = firstNameError;
  }

  const lastNameError = validateLastName(formValues.lastName);
  if (lastNameError) {
    errors.lastName = lastNameError;
  }

  return errors;
};

export const submitAccountUpdate = async ({
  isPhoneIncorrect,
  numero,
  phoneObj,
  user,
  firstName,
  lastName,
  dispatch,
  setLoading,
}: any) => {
  if (!isPhoneIncorrect && numero) {
    await updateAccount({
      setLoading,
      phoneObj,
      updateProfile,
      showUpdateInfo,
      user,
      firstName,
      lastName,
      numero,
      dispatch,
    });

    analyticsEvents.logProfileUpdate(user.customerId);
  }
};

export const handleAccountDeletion = ({
  dispatch,
  user,
  isUserAnonymous,
  navigate,
}: any) => {
  openMessageModal(TEXT_VALIDATION_DELETE_ACCOUNT, {
    showCancel: true,
    title: "Supprimer mon compte",
    buttonName: "supprimer mon compte",
    subTitle: TEXT_VALIDATION_DELETE_ACCOUNT,
    text: "Confirmation de suppression",
    buttonCancelName: "Conserver mon compte",
    primaryColor: "error",
    withImage: true,
    image: "error",
    onClick: () => {
      deleteUserAccount({
        showUpdateInfo,
        showAccountModal,
        userSignOut,
        customerId: user.customerId,
        isUserAnonymous,
        updateUser,
        dispatch,
        navigate,
      });
    },
  });

  analyticsEvents.logAccountDeletion(user.customerId);
};
